import { isDefined } from "@clipboard-health/util-ts";
import { CircularProgress } from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

import { AGENT_VISITS_PATH } from "./paths";

const AgentVisitsPage = lazy(async () =>
  import("./AgentVisitsPage").then((module) => ({
    default: module.AgentVisitsPage,
  }))
);

export function ProtectedAgentVisitsPage() {
  const { userId, admin } = useSession();
  const isLoggedIn = isDefined(userId);

  if (!isLoggedIn) {
    localStorage.setItem("redirectURL", AGENT_VISITS_PATH);
    return <Redirect to={`/enter?requestedUrl=${AGENT_VISITS_PATH}`} />;
  }

  if (!admin) {
    return <Redirect to="/" />;
  }

  return (
    <Suspense fallback={<CircularProgress />}>
      <AgentVisitsPage />
    </Suspense>
  );
}
